import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivacyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivacyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 22.0002C11.9551 22.0002 11.9106 21.9944 11.8667 21.9822C11.7871 21.9602 3.91016 19.6833 3.91016 10.8826V5.67554C3.91016 5.47388 4.03125 5.29224 4.21729 5.21411L11.8071 2.03882C11.9302 1.98706 12.0698 1.98706 12.1929 2.03882L19.7827 5.21411C19.9687 5.29223 20.0898 5.47388 20.0898 5.67554V10.8826C20.0898 19.6833 12.2129 21.9602 12.1333 21.9822C12.0893 21.9944 12.0449 22.0002 12 22.0002ZM4.91016 6.00855V10.8826C4.91016 18.3967 10.9834 20.6531 12 20.9778C13.0166 20.6531 19.0898 18.3967 19.0898 10.8826V6.00855L12 3.04224L4.91016 6.00855Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0005 16.2732C11.7241 16.2732 11.5005 16.0496 11.5005 15.7732V10.9612C11.5005 10.6848 11.7241 10.4612 12.0005 10.4612C12.2769 10.4612 12.5005 10.6848 12.5005 10.9612V15.7732C12.5005 16.0496 12.2769 16.2732 12.0005 16.2732Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0005 8.72144C11.7241 8.72144 11.5005 8.50855 11.5005 8.23218V8.2107C11.5005 7.93433 11.7241 7.7107 12.0005 7.7107C12.2769 7.7107 12.5005 7.93433 12.5005 8.2107C12.5005 8.48707 12.2769 8.72144 12.0005 8.72144Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivacyIcon;
